var map = {
	"./bone_marrow.png": "dac1",
	"./brain.png": "1003",
	"./favicon-32x32.png": "7c66",
	"./files_icon.png": "df9b",
	"./heart.png": "fa49",
	"./infectious_disease.png": "e15f",
	"./logo.png": "cf05",
	"./module.png": "0d65",
	"./modules_icon.png": "5d49",
	"./pumas-brand-footer.png": "4494",
	"./pumas-brand-header.png": "8ba5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9142";